var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import styled, { css } from 'styled-components';
import { Variants, Types } from './types';
import { Breakpoints, Spacing, withTheming } from '@doordash/design-language';

var getColorSet = function getColorSet(_ref) {
  var _Types$Default, _Types$Emphasis, _Types$Subdued, _styleConfig;

  var variant = _ref.variant,
      type = _ref.type,
      theme = _ref.theme;
  var BORDER_WIDTH = theme.BorderWidth.Default;
  var BIG_BORDER_WIDTH = 4;
  var styleConfig = (_styleConfig = {}, _defineProperty(_styleConfig, Types.Default, (_Types$Default = {}, _defineProperty(_Types$Default, Variants.Positive, {
    background: theme.Colors.BannerPositiveDefaultBackground
  }), _defineProperty(_Types$Default, Variants.Negative, {
    background: theme.Colors.BannerNegativeDefaultBackground
  }), _defineProperty(_Types$Default, Variants.Highlight, {
    background: theme.Colors.BannerHighlightDefaultBackground
  }), _defineProperty(_Types$Default, Variants.Informational, {
    background: theme.Colors.BannerInformationalDefaultBackground
  }), _defineProperty(_Types$Default, Variants.Warning, {
    background: theme.Colors.BannerWarningDefaultBackground
  }), _Types$Default)), _defineProperty(_styleConfig, Types.Emphasis, (_Types$Emphasis = {}, _defineProperty(_Types$Emphasis, Variants.Positive, {
    background: theme.Colors.BannerPositiveEmphasisBackground
  }), _defineProperty(_Types$Emphasis, Variants.Negative, {
    background: theme.Colors.BannerNegativeEmphasisBackground
  }), _defineProperty(_Types$Emphasis, Variants.Highlight, {
    background: theme.Colors.BannerHighlightEmphasisBackground
  }), _defineProperty(_Types$Emphasis, Variants.Informational, {
    background: theme.Colors.BannerInformationalEmphasisBackground
  }), _defineProperty(_Types$Emphasis, Variants.Warning, {
    background: theme.Colors.BannerWarningEmphasisBackground
  }), _Types$Emphasis)), _defineProperty(_styleConfig, Types.Subdued, (_Types$Subdued = {}, _defineProperty(_Types$Subdued, Variants.Positive, {
    background: theme.Colors.BannerPositiveSubduedBackground,
    border: theme.Colors.BannerPositiveSubduedBorder,
    borderLeft: theme.Colors.BannerPositiveSubduedDecorator
  }), _defineProperty(_Types$Subdued, Variants.Negative, {
    background: theme.Colors.BannerNegativeSubduedBackground,
    border: theme.Colors.BannerNegativeSubduedBorder,
    borderLeft: theme.Colors.BannerNegativeSubduedDecorator
  }), _defineProperty(_Types$Subdued, Variants.Highlight, {
    background: theme.Colors.BannerHighlightSubduedBackground,
    border: theme.Colors.BannerHighlightSubduedBorder,
    borderLeft: theme.Colors.BannerHighlightSubduedDecorator
  }), _defineProperty(_Types$Subdued, Variants.Informational, {
    background: theme.Colors.BannerInformationalSubduedBackground,
    border: theme.Colors.BannerInformationalSubduedBorder,
    borderLeft: theme.Colors.BannerInformationalSubduedDecorator
  }), _defineProperty(_Types$Subdued, Variants.Warning, {
    background: theme.Colors.BannerWarningSubduedBackground,
    border: theme.Colors.BannerWarningSubduedBorder,
    borderLeft: theme.Colors.BannerWarningSubduedDecorator
  }), _Types$Subdued)), _styleConfig);

  if (type === Types.Subdued) {
    var subduedStyles = styleConfig.Subdued[variant];
    return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      background: ", ";\n      border: ", "px solid ", ";\n      border-left: ", "px solid ", ";\n    "])), subduedStyles.background, BORDER_WIDTH, subduedStyles.border, BIG_BORDER_WIDTH, subduedStyles.borderLeft);
  }

  var styles = styleConfig[type][variant];
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    background: ", ";\n  "])), styles.background);
};

export var BannerWrapper = withTheming(styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", "\n  border-radius: ", "px;\n  padding: ", "px;\n  display: grid;\n  grid-gap: ", "px;\n  grid-template-columns: auto 1fr ", ";\n\n  & > button {\n    align-self: start;\n  }\n"])), function (props) {
  return getColorSet(props);
}, function (props) {
  return props.isGlobal ? props.theme.BorderRadius.None : props.theme.BorderRadius.BannerDefault;
}, Spacing.Small, Spacing.Small, function (props) {
  return props.hasCloseButton ? ' auto' : '';
}));
export var BannerContentWrapper = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: ", "px;\n  flex-flow: row wrap;\n\n  @media (min-width: ", "px) {\n    justify-content: space-between;\n    flex-flow: row nowrap;\n  }\n"])), Spacing.XxSmall, Breakpoints.Mobile);
export var BannerActionsWrapper = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  flex-direction: row-reverse;\n  gap: ", "px;\n\n  @media (min-width: ", "px) {\n    flex-direction: row;\n  }\n\n  & > button {\n    flex-basis: auto;\n  }\n"])), Spacing.XxSmall, Breakpoints.Mobile);
export var IconContainer = withTheming(styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  height: ", "px;\n  width: ", "px;\n  border-radius: 50%;\n  background: ", ";\n  color: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])), function (props) {
  return props.type === Types.Subdued ? Spacing.XLarge : Spacing.Large;
}, function (props) {
  return props.type === Types.Subdued ? Spacing.XLarge : Spacing.Large;
}, function (props) {
  return props.theme.Colors["Banner".concat(props.variant).concat(props.type, "IconBackground")];
}, function (props) {
  return props.theme.Colors["Banner".concat(props.variant).concat(props.type, "Icon")];
}));